export interface CatalogPhoto {
  id: string;
  file: string;
  width: number;
  height: number;
  /** Horizon as a fraction of the photo height, 0 = top. */
  horizon: number;
  title: string;
  creator: string;
  source: string;
  license: string;
}

export interface Catalog {
  photos: CatalogPhoto[];
}

export async function loadCatalog(): Promise<Catalog> {
  const res = await fetch('/catalog.json', { cache: 'no-cache' });
  if (!res.ok) throw new Error(`catalog ${res.status}`);
  const data = (await res.json()) as Catalog;
  if (!Array.isArray(data.photos) || data.photos.length === 0) throw new Error('empty catalog');
  return data;
}

export function findPhoto(catalog: Catalog, id: string): CatalogPhoto | undefined {
  return catalog.photos.find((p) => p.id === id);
}
